<mat-drawer-container class="h-screen overflow-hidden">
  <!-- Sidebar responsive -->
  <mat-drawer
    class="bg-[#F1F2F7] h-screen w-64"
    [autoFocus]="true"
    [mode]="drawerMode"
    [opened]="drawerOpened"
    #drawer
  >
    <app-sidebar></app-sidebar>
  </mat-drawer>

  <!-- Main content -->
  <mat-drawer-content class="overflow-hidden">
    <app-auth-header (toggleSidebar)="drawer.toggle()"></app-auth-header>
    <main class="h-screen-16 w-full overflow-x-hidden overflow-y-auto">
      <router-outlet></router-outlet>
    </main>
  </mat-drawer-content>
</mat-drawer-container>
